// frontend/src/utils/auth.js

export const handleAuthError = (navigate) => {
  // Remove the token from local storage to log the user out
  localStorage.removeItem('token');
  // Redirect to the landing page
  navigate('/');
};


